<router-outlet></router-outlet>

@if(alarmService.showEmergencyModal()){
<p-dialog
  header="Επείγον περιστατικό"
  [modal]="true"
  [visible]="alarmService.showEmergencyModal()"
  [style]="{ width: '40rem' }"
>
  <span class="p-text-secondary block mb-5"
    >Μια νέα επείγουσα ειδοποίηση εμφανίστηκε!</span
  >

  <div class="flex justify-content-end gap-2">
    <p-button label="Πλοήγηση" (onClick)="handleEmergencyAlert()" />
  </div>
</p-dialog>
}
